// import React, { useContext, useEffect, useState } from "react";
// import { FiEdit } from "react-icons/fi";
// import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";
// import formateText from "../../../utils/Formate";
// import { MdPreview } from "react-icons/md";
// import { MdOutlineArrowForwardIos } from "react-icons/md";
// import { MdOutlineArrowBackIosNew } from "react-icons/md";

// const HistoryTable = ({
//   headers,
//   fetchedData,
//   clearActiveRow,
//   row,
//   editCallBack,
//   notEditAble,
//   noSearch,
//   extraFields,
//   notSearchAble,
//   small,
//   onSelectCallBack,
// }) => {
//   const {
//     companys,
//     isAllDataFetched,
//     branchs,
//     measurementUnits,
//     devices,
//     cargoTypes,
//     routes,
//     functions,
//     agent,
//     boxName,
//     measurementUnit,
//     device,
//     scanningPoint,
//     scanningPerson,
//     parcelStatus,
//     allUser,
//     onSelect,
//   } = useContext(contextProvider);

//   // main array of object.
//   const [data, setData] = useState(null);

//   // set array of object data.
//   useEffect(() => {
//     if (fetchedData) setData(fetchedData);
//   }, [fetchedData]);

//   const typeValidation = (field, fetchedObject) => {
//     if (
//       !fetchedObject[field] &&
//       field !== "boxAssignPreviousMonth" &&
//       field !== "limitCurrentMonth" &&
//       field !== "boxAssignCurrentMonth" &&
//       field !== "limitPreviousMonth" &&
//       field !== "isAgent" &&
//       field !== "boxQty" &&
//       field !== "isHub" &&
//       field !== "isOffice" &&
//       field !== "isActive" &&
//       field !== "isExpressService" &&
//       field !== "receiveQty" &&
//       field !== "adjustmentQty" &&
//       field !== "Route Cost" &&
//       field !== "Dimension Cost" && //
//       field !== "Weight Cost" &&
//       field !== "Item Type Cost" &&
//       field !== "Additional Cost" &&
//       field !== "Cargo Type Cost" &&
//       field !== "Extra Packaging Cost" &&
//       field !== "Pickup Cost" &&
//       field !== "Total" && //
//       field !== "issueQty"
//     ) {
//       return <span className="text-red-400">Not Available</span>;
//     }

//     if (field === "isActive" && fetchedObject[field] === true) return "Active";
//     if (field === "isActive" && fetchedObject[field] === false)
//       return "Inactive";

//     if (
//       (field === "isExpressService" ||
//         field === "isHub" ||
//         field === "isOffice" ||
//         field === "isAgent") &&
//       fetchedObject[field] === true
//     )
//       return "Yes";
//     if (
//       (field === "isExpressService" ||
//         field === "isHub" ||
//         field === "isOffice" ||
//         field === "isAgent") &&
//       fetchedObject[field] === false
//     )
//       return "No";

//     if (field === "parcelStatusId") {
//       let data = parcelStatus?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.parcelStatusName;

//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "scanningPersonId") {
//       let data = scanningPerson?.find(
//         (item) => item.userId === fetchedObject[field]
//       )?.userName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "scanningPointId") {
//       let data = scanningPoint?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.scanningPointName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "measurementUnitId") {
//       let data = measurementUnit?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.unitDescription;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "deviceId") {
//       let data = device?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.deviceName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "dimensionId") {
//       let data = boxName?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.dimensionName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "agentId" || field === "transportAgentId") {
//       let data = agent?.find((item) => item.id === fetchedObject[field])?.name;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "companyId") {
//       let data = companys?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.name;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "routeId") {
//       let data = routes?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.routeName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "cargoId") {
//       let data = cargoTypes?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.cargoTypeName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "MeasurementUnitId") {
//       // need to update.
//       let data = measurementUnits?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.cargoTypeName;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "issuedBy") {
//       // need to update.
//       let data = allUser?.find(
//         (item) => item.id === fetchedObject[field]
//       )?.roleName;

//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (
//       field === "startDate" ||
//       field === "paymentDate" ||
//       field === "issueDate" ||
//       field === "transactionDate"
//     ) {
//       const date = new Date(fetchedObject[field]);

//       let data = `${date.getDate()}/${
//         date.getMonth() + 1
//       }/${date.getFullYear()}`;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "endDate") {
//       const date = new Date(fetchedObject[field]);
//       let data = `${date.getDate()}/${
//         date.getMonth() + 1
//       }/${date.getFullYear()}`;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }
//     if (field === "discountedDate") {
//       const date = new Date(fetchedObject[field]);
//       let data = `${date.getDate()}/${
//         date.getMonth() + 1
//       }/${date.getFullYear()}`;
//       if (!data) return <span className="text-red-400">Not Available</span>;
//       return data;
//     }

//     return fetchedObject[field];
//   };

//   const [activeRow, setActiveRow] = useState(null);

//   useEffect(() => {
//     if (clearActiveRow) setActiveRow(null);
//   }, [clearActiveRow]);

//   useEffect(() => {
//     setActiveRow(null);
//   }, [fetchedData]);

//   // pageination logics. every page have 10 row.

//   // per page data limit.
//   const limit = 10;

//   // get array of pagination page number.
//   const getbuttonNumbersArray = (start, end) => {
//     const numbersArray = [];
//     for (let i = start; i <= end; i++) {
//       numbersArray.push(i);
//     }
//     return numbersArray;
//   };

//   // split data.
//   const splitData = (pageNo) => {
//     const startingIndex = (pageNo - 1) * limit;
//     const endingIndex = pageNo * limit;
//     const splitedData = fetchedData?.slice(startingIndex, endingIndex);
//     setData(splitedData);
//   };

//   // call array spliting function.
//   const [pageNo, setPageNo] = useState(1);

//   useEffect(() => {
//     splitData(pageNo);
//   }, [pageNo, fetchedData]);

//   const totalPaginationPage = Math.ceil(fetchedData?.length / limit);
//   const [PaginationButtonNumbers, setPaginationButtonNumbers] = useState([]);

//   const [reArange, setRearange] = useState(false);
//   useEffect(() => {
//     if (totalPaginationPage < 4)
//       return setPaginationButtonNumbers(
//         getbuttonNumbersArray(1, totalPaginationPage)
//       );
//     return setPaginationButtonNumbers(getbuttonNumbersArray(1, 4));
//   }, [fetchedData, reArange]);

//   const skipPaginationNumber = (start, end) => {
//     setPaginationButtonNumbers(getbuttonNumbersArray(start, end));
//   };

//   // modal controll.
//   const [showModal, setShowMOdal] = useState(null);
//   const [modalData, setModalData] = useState(null);

//   const TableSearchHandle = (e) => {
//     e.preventDefault();
//     const searchAbleText = e.target.searchText.value;
//     if (!fetchedData) return;

//     const isInclued = (values) => {
//       for (let item of values) {
//         if (item !== null && item !== undefined) {
//           const preferedItem = item.toString().toLowerCase();
//           const preferedSearchText = searchAbleText.toString().toLowerCase();
//           if (preferedItem.includes(preferedSearchText)) return true;
//         }
//       }
//       return false;
//     };

//     const filteredData = fetchedData.filter((item) => {
//       const itemValuesArray = Object.values(item);
//       return isInclued(itemValuesArray);
//     });

//     setData(filteredData);
//   };

//   // clear search .
//   const clearSearch = () => {
//     setData(fetchedData);
//     setSearchText("");
//   };

//   const [searchText, setSearchText] = useState("");

//   return (
//     <div className={small ? "scale-95 text-end" : "text-end"}>
//       {!notSearchAble && (
//         <form
//           onSubmit={TableSearchHandle}
//           className={
//             noSearch
//               ? "hidden"
//               : "xl:w-[30%] w-full  inline-flex items-center lg:gap-x-2 gap-x-1 justify-between lg:justify-end mb-4"
//           }
//         >
//           <input
//             onChange={(e) => setSearchText(e.target.value)}
//             value={searchText}
//             required
//             className="w-full lg:w-[30%] xl:w-full border-2 lg:border-[3px] pl-2  border-[#83430D] h-10 lg:h-12 outline-none rounded-lg bg-transparent"
//             type="text"
//             name="searchText"
//             placeholder="You text here"
//           />
//           <button
//             className={`font-medium  text-base lg:text-lg bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[8px] h-[40px] lg:h-[47px] px-4 lg:px-6  text-white`}
//           >
//             Search
//           </button>
//           <button
//             onClick={clearSearch}
//             type="button"
//             className={`font-medium  text-base lg:text-lg bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[8px] h-[40px] lg:h-[47px] px-4 lg:px-6  text-white`}
//           >
//             Clear
//           </button>
//         </form>
//       )}
//       <div className=" w-full  overflow-x-auto rounded-lg overflow-hidden bg-[#fceee5]">
//         <div className="">
//           <table className="w-full">
//             <thead className="">
//               <tr className="  w-full bg-[#f5cfb5] lg:text-lg text-sm text-center">
//                 {!notSearchAble && <th className="lg:py-4 py-3 px-4">S/N</th>}
//                 {headers?.map((item) => (
//                   <th
//                     key={item}
//                     className=" lg:py-4 py-3 px-4 text-base lg:text-lg  w-max"
//                   >
//                     <span className="w-max inline-block">
//                       {formateText(item)}
//                     </span>
//                   </th>
//                 ))}
//                 {!notSearchAble && (
//                   <th className={notEditAble ? "hidden" : "py-4 px-12"}></th>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {isAllDataFetched &&
//                 data?.map((item, index) => {
//                   // return tr.
//                   const fetchedObject = item;

//                   const editFuncData = {
//                     id: fetchedObject?.id,
//                     modificationDate: new Date(),
//                   };
//                   extraFields?.forEach(
//                     (field) => (editFuncData[field] = fetchedObject[field])
//                   );

//                   const td = row?.map((field, idx) => {
//                     editFuncData[field] = fetchedObject[field];

//                     return (
//                       <td
//                         key={idx}
//                         className="text-center text-sm lg:text-base font-normal lg:font-semibold lg:py-3 py-2 px-4 w-max hover:bg-gray-100 hover:text-blue-600 transition-colors duration-200"
//                         onClick={() => {
//                           if (onSelectCallBack) {
//                             onSelectCallBack(item);
//                           }
//                         }}
//                         style={{
//                           cursor: onSelectCallBack ? "pointer" : "default",
//                         }}
//                       >
//                         <span className="w-max inline-block">
//                           {typeValidation(field, fetchedObject)}
//                         </span>
//                       </td>
//                     );
//                   }); // return td.

//                   return (
//                     <tr
//                       key={index}
//                       className={
//                         activeRow === index
//                           ? "bg-[#ee9d67]"
//                           : index % 2 !== 0
//                           ? "bg-[#fce8db] "
//                           : "bg-[#fcf4ef]"
//                       }
//                     >
//                       {!notSearchAble && (
//                         <td className="text-center lg:py-3 py-2 font-normal lg:font-semibold">
//                           {(pageNo - 1) * limit + (index + 1)}
//                         </td>
//                       )}

//                       {td}
//                       <td className="flex justify-center items-center gap-2">
//                         <button
//                           className={
//                             notEditAble
//                               ? "hidden"
//                               : "text-center py-3 font-semibold flex justify-center items-center text-xl text-[#c26040]"
//                           }
//                           onClick={() => {
//                             editCallBack(editFuncData);
//                             setActiveRow(index);
//                           }}
//                         >
//                           <FiEdit />
//                         </button>

//                         <button
//                           className={
//                             notEditAble
//                               ? "hidden"
//                               : "text-center py-3 font-semibold flex justify-center items-center text-xl text-[#c26040]"
//                           }
//                           onClick={() => {
//                             // editCallBack(editFuncData);
//                             setActiveRow(index);
//                           }}
//                         >
//                           <MdPreview />
//                         </button>
//                       </td>
//                     </tr>
//                   );
//                 })}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       <div
//         className={
//           fetchedData?.length <= limit
//             ? "hidden"
//             : "flex items-center gap-x-1 m-auto justify-center mb-11 mt-4"
//         }
//       >
//         <button
//           onClick={() => {
//             if (
//               pageNo === PaginationButtonNumbers[0] &&
//               (pageNo < totalPaginationPage) & (pageNo > 1)
//             ) {
//               if (totalPaginationPage >= pageNo - 4 && pageNo - 4 >= 1)
//                 skipPaginationNumber(pageNo - 4, pageNo);
//               else if (1 > pageNo - 4) skipPaginationNumber(1, pageNo);
//             }
//             if (1 < pageNo) {
//               setPageNo((prev) => prev - 1);
//             }
//           }}
//           className={
//             "font-medium  text-base bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-white"
//           }
//         >
//           <MdOutlineArrowBackIosNew className="lg:text-xl text-sm" />
//         </button>

//         <button
//           onClick={() => {
//             if ((pageNo <= totalPaginationPage) & (pageNo > 1)) {
//               if (totalPaginationPage >= pageNo - 4 && pageNo - 4 >= 1) {
//                 skipPaginationNumber(pageNo - 4, pageNo);
//                 setPageNo((prev) => prev - 4);
//               } else if (1 > pageNo - 4) {
//                 skipPaginationNumber(1, pageNo);
//                 setPageNo((prev) => prev - (pageNo - 1));
//               }
//             }
//           }}
//           className={
//             "font-medium  text-2xl  rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-black"
//           }
//         >
//           ...
//         </button>

//         {PaginationButtonNumbers?.map((item) => {
//           return (
//             <button
//               onClick={() => setPageNo(item)}
//               className={`font-medium  text-base bg-gradient-to-tr ${
//                 pageNo === item
//                   ? "from-[#b9b89b] to-[#b3b3ae]"
//                   : "from-[#6D4C41] to-[#424242]"
//               } rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-white`}
//               key={item}
//             >
//               {item}
//             </button>
//           );
//         })}

//         <button
//           onClick={() => {
//             if (pageNo < totalPaginationPage) {
//               if (totalPaginationPage >= pageNo + 4) {
//                 skipPaginationNumber(pageNo, pageNo + 4);
//                 setPageNo((prev) => prev + 4);
//               } else if (totalPaginationPage < pageNo + 4) {
//                 skipPaginationNumber(pageNo, totalPaginationPage);
//                 setPageNo((prev) => prev + totalPaginationPage - pageNo);
//               }
//             }
//           }}
//           className={
//             "font-medium  text-2xl  rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-black"
//           }
//         >
//           ...
//         </button>
//         <button
//           onClick={() => {
//             if (
//               pageNo ===
//                 PaginationButtonNumbers[PaginationButtonNumbers.length - 1] &&
//               pageNo < totalPaginationPage
//             ) {
//               if (totalPaginationPage >= pageNo + 4)
//                 skipPaginationNumber(pageNo, pageNo + 4);
//               else if (totalPaginationPage < pageNo + 4)
//                 skipPaginationNumber(pageNo, totalPaginationPage);
//             }
//             if (totalPaginationPage > pageNo) {
//               setPageNo((prev) => prev + 1);
//             }
//           }}
//           className={
//             "font-medium  text-base bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[3px] px-3 lg:px-4 py-[6px]  lg:py-[10px] text-white"
//           }
//         >
//           <MdOutlineArrowForwardIos className="lg:text-xl text-sm" />
//         </button>
//       </div>

//       {/* You can open the modal using document.getElementById('ID').showModal() method */}
//       {/* <button
//         className="btn"
//         onClick={() => document.getElementById("my_modal_3").showModal()}
//       >
//         open modal
//       </button> */}
//       <dialog id="my_modal_3" className="modal">
//         <div className="modal-box">
//           <form method="dialog">
//             {/* if there is a button in form, it will close the modal */}
//             <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
//               ✕
//             </button>
//           </form>
//           <h3 className="font-bold text-lg">Hello!</h3>
//           <p className="py-4">Press ESC key or click on ✕ button to close</p>
//         </div>
//       </dialog>
//     </div>
//   );
// };

// export default HistoryTable;



import React, { useContext, useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";
import formateText from "../../../utils/Formate";
import { MdPreview } from "react-icons/md";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import axios from "axios";
import { formatCurrency } from "../../../utils/formatCurrency";

const HistoryTable = ({
  headers,
  fetchedData,
  clearActiveRow,
  row,
  editCallBack,
  notEditAble,
  noSearch,
  extraFields,
  notSearchAble,
  small,
  onSelectCallBack,
  showViewCost = false,
}) => {
  const {
    companys,
    isAllDataFetched,
    branchs,
    measurementUnits,
    devices,
    cargoTypes,
    routes,
    functions,
    agent,
    boxName,
    dimensions,
    measurementUnit,
    device,
    scanningPoint,
    scanningPerson,
    parcelStatus,
    allUser,
    onSelect,
  } = useContext(contextProvider);

  // State for table data
  const [data, setData] = useState(null);
  const [activeRow, setActiveRow] = useState(null);

  // State for cost details modal
  const [showCostModal, setShowCostModal] = useState(false);
  const [parcelCostData, setParcelCostData] = useState(null);
  const [loadingCostData, setLoadingCostData] = useState(false);
  const [currentParcelNo, setCurrentParcelNo] = useState(null);

  // Pagination states
  const [pageNo, setPageNo] = useState(1);
  const [PaginationButtonNumbers, setPaginationButtonNumbers] = useState([]);
  const [reArange, setRearange] = useState(false);

  // Search state
  const [searchText, setSearchText] = useState("");
  const backendUrl = process.env.REACT_APP_API_URL;
  // Set array of object data
  useEffect(() => {
    if (fetchedData) setData(fetchedData);
  }, [fetchedData]);

  // Clear active row when needed
  useEffect(() => {
    if (clearActiveRow) setActiveRow(null);
  }, [clearActiveRow]);

  useEffect(() => {
    setActiveRow(null);
  }, [fetchedData]);

  // Fetch parcel cost details
  const fetchParcelCostDetails = (parcelNo) => {
  setCurrentParcelNo(parcelNo);
  setLoadingCostData(true);

  axios
    .get(`${backendUrl}ParcelDetails/GetParcelCostDetails?parcelNo=${parcelNo}`)
    .then((res) => {
      setParcelCostData(res.data);
      setShowCostModal(true);
    })
    .catch((error) => {
      console.error("Error fetching parcel cost details:", error.message);
      // Optional: show toast or alert here
    })
    .finally(() => {
      setLoadingCostData(false);
    });
};


  // Type validation for table cells
   const typeValidation = (field, fetchedObject) => {
    if (
      !fetchedObject[field] &&
      field !== "boxAssignPreviousMonth" &&
      field !== "limitCurrentMonth" &&
      field !== "boxAssignCurrentMonth" &&
      field !== "limitPreviousMonth" &&
      field !== "isAgent" &&
      field !== "boxQty" &&
      field !== "isHub" &&
      field !== "isOffice" &&
      field !== "isActive" &&
      field !== "isExpressService" &&
      field !== "receiveQty" &&
      field !== "adjustmentQty" &&
      field !== "Route Cost" &&
      field !== "Dimension Cost" && //
      field !== "Weight Cost" &&
      field !== "Item Type Cost" &&
      field !== "Additional Cost" &&
      field !== "Cargo Type Cost" &&
      field !== "Extra Packaging Cost" &&
      field !== "Pickup Cost" &&
      field !== "Total" && //
      field !== "issueQty"
    ) {
      return <span className="text-red-400">Not Available</span>;
    }

    if (field === "isActive" && fetchedObject[field] === true) return "Active";
    if (field === "isActive" && fetchedObject[field] === false)
      return "Inactive";

    if (
      (field === "isExpressService" ||
        field === "isHub" ||
        field === "isOffice" ||
        field === "isAgent") &&
      fetchedObject[field] === true
    )
      return "Yes";
    if (
      (field === "isExpressService" ||
        field === "isHub" ||
        field === "isOffice" ||
        field === "isAgent") &&
      fetchedObject[field] === false
    )
      return "No";

    if (field === "parcelStatusId") {
      let data = parcelStatus?.find(
        (item) => item.id === fetchedObject[field]
      )?.parcelStatusName;

      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "scanningPersonId") {
      let data = scanningPerson?.find(
        (item) => item.userId === fetchedObject[field]
      )?.userName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "scanningPointId") {
      let data = scanningPoint?.find(
        (item) => item.id === fetchedObject[field]
      )?.scanningPointName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "measurementUnitId") {
      let data = measurementUnit?.find(
        (item) => item.id === fetchedObject[field]
      )?.unitDescription;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "deviceId") {
      let data = device?.find(
        (item) => item.id === fetchedObject[field]
      )?.deviceName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "dimensionId") {
      // Try dimensions first (new state), fallback to boxName for backward compatibility
      let data = dimensions?.find(
        (item) => item.id === fetchedObject[field]
      )?.dimensionName || boxName?.find(
        (item) => item.id === fetchedObject[field]
      )?.dimensionName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "dimensionName") {
      // Direct dimensionName field from API response
      return fetchedObject[field] || <span className="text-red-400">Not Available</span>;
    }
    if (field === "agentId" || field === "transportAgentId") {
      let data = agent?.find((item) => item.id === fetchedObject[field])?.name;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "companyId") {
      let data = companys?.find(
        (item) => item.id === fetchedObject[field]
      )?.name;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "routeId") {
      let data = routes?.find(
        (item) => item.id === fetchedObject[field]
      )?.routeName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "cargoId") {
      let data = cargoTypes?.find(
        (item) => item.id === fetchedObject[field]
      )?.cargoTypeName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "MeasurementUnitId") {
      // need to update.
      let data = measurementUnits?.find(
        (item) => item.id === fetchedObject[field]
      )?.cargoTypeName;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "issuedBy") {
      // need to update.
      let data = allUser?.find(
        (item) => item.id === fetchedObject[field]
      )?.roleName;

      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (
      field === "startDate" ||
      field === "paymentDate" ||
      field === "issueDate" ||
      field === "transactionDate"
    ) {
      const date = new Date(fetchedObject[field]);

      let data = `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()}`;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "endDate") {
      const date = new Date(fetchedObject[field]);
      let data = `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()}`;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }
    if (field === "discountedDate") {
      const date = new Date(fetchedObject[field]);
      let data = `${date.getDate()}/${
        date.getMonth() + 1
      }/${date.getFullYear()}`;
      if (!data) return <span className="text-red-400">Not Available</span>;
      return data;
    }

    return fetchedObject[field];
  };

  // Pagination logic
  const limit = 10;

  const getbuttonNumbersArray = (start, end) => {
    const numbersArray = [];
    for (let i = start; i <= end; i++) {
      numbersArray.push(i);
    }
    return numbersArray;
  };

  const splitData = (pageNo) => {
    const startingIndex = (pageNo - 1) * limit;
    const endingIndex = pageNo * limit;
    const splitedData = fetchedData?.slice(startingIndex, endingIndex);
    setData(splitedData);
  };

  useEffect(() => {
    splitData(pageNo);
  }, [pageNo, fetchedData]);

  const totalPaginationPage = Math.ceil(fetchedData?.length / limit);

  useEffect(() => {
    if (totalPaginationPage < 4)
      return setPaginationButtonNumbers(
        getbuttonNumbersArray(1, totalPaginationPage)
      );
    return setPaginationButtonNumbers(getbuttonNumbersArray(1, 4));
  }, [fetchedData, reArange]);

  const skipPaginationNumber = (start, end) => {
    setPaginationButtonNumbers(getbuttonNumbersArray(start, end));
  };

  // Table search handler
  const TableSearchHandle = (e) => {
    e.preventDefault();
    const searchAbleText = e.target.searchText.value;
    if (!fetchedData) return;

    const isInclued = (values) => {
      for (let item of values) {
        if (item !== null && item !== undefined) {
          const preferedItem = item.toString().toLowerCase();
          const preferedSearchText = searchAbleText.toString().toLowerCase();
          if (preferedItem.includes(preferedSearchText)) return true;
        }
      }
      return false;
    };

    const filteredData = fetchedData.filter((item) => {
      const itemValuesArray = Object.values(item);
      return isInclued(itemValuesArray);
    });

    setData(filteredData);
  };

  // Clear search
  const clearSearch = () => {
    setData(fetchedData);
    setSearchText("");
  };

  return (
    <div className={small ? "scale-95 text-end" : "text-end"}>
      {!notSearchAble && (
        <form
          onSubmit={TableSearchHandle}
          className={
            noSearch
              ? "hidden"
              : "xl:w-[30%] w-full  inline-flex items-center lg:gap-x-2 gap-x-1 justify-between lg:justify-end mb-4"
          }
        >
          <input
            onChange={(e) => setSearchText(e.target.value)}
            value={searchText}
            required
            className="w-full lg:w-[30%] xl:w-full border-2 lg:border-[3px] pl-2  border-[#83430D] h-10 lg:h-12 outline-none rounded-lg bg-transparent"
            type="text"
            name="searchText"
            placeholder="You text here"
          />
          <button
            className={`font-medium  text-base lg:text-lg bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[8px] h-[40px] lg:h-[47px] px-4 lg:px-6  text-white`}
          >
            Search
          </button>
          <button
            onClick={clearSearch}
            type="button"
            className={`font-medium  text-base lg:text-lg bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[8px] h-[40px] lg:h-[47px] px-4 lg:px-6  text-white`}
          >
            Clear
          </button>
        </form>
      )}
      <div className=" w-full  overflow-x-auto rounded-lg overflow-hidden bg-[#fceee5]">
        <div className="">
          <table className="w-full">
            <thead className="">
              <tr className="  w-full bg-[#f5cfb5] lg:text-lg text-sm text-center">
                {!notSearchAble && <th className="lg:py-4 py-3 px-4">S/N</th>}
                {headers?.map((item) => (
                  <th
                    key={item}
                    className=" lg:py-4 py-3 px-4 text-base lg:text-lg  w-max"
                  >
                    <span className="w-max inline-block">
                      {formateText(item)}
                    </span>
                  </th>
                ))}
                {!notSearchAble && (
                  <th className={notEditAble ? "hidden" : "py-4 px-12"}>Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {isAllDataFetched &&
                data?.map((item, index) => {
                  const fetchedObject = item;
                  const editFuncData = {
                    id: fetchedObject?.id,
                    modificationDate: new Date(),
                  };
                  extraFields?.forEach(
                    (field) => (editFuncData[field] = fetchedObject[field])
                  );

                  const td = row?.map((field, idx) => {
                    editFuncData[field] = fetchedObject[field];

                    return (
                      <td
                        key={idx}
                        className="text-center text-sm lg:text-base font-normal lg:font-semibold lg:py-3 py-2 px-4 w-max hover:bg-gray-100 hover:text-blue-600 transition-colors duration-200"
                        onClick={() => {
                          if (onSelectCallBack) {
                            onSelectCallBack(item);
                          }
                        }}
                        style={{
                          cursor: onSelectCallBack ? "pointer" : "default",
                        }}
                      >
                        <span className="w-max inline-block">
                          {typeValidation(field, fetchedObject)}
                        </span>
                      </td>
                    );
                  });

                  return (
                    <tr
                      key={index}
                      className={
                        activeRow === index
                          ? "bg-[#ee9d67]"
                          : index % 2 !== 0
                          ? "bg-[#fce8db] "
                          : "bg-[#fcf4ef]"
                      }
                    >
                      {!notSearchAble && (
                        <td className="text-center lg:py-3 py-2 font-normal lg:font-semibold">
                          {(pageNo - 1) * limit + (index + 1)}
                        </td>
                      )}

                      {td}
                      <td className="flex justify-center items-center gap-2">
                        {!notEditAble && (
                          <>
                            <button
                              className="text-center py-3 font-semibold flex justify-center items-center text-xl text-[#c26040]"
                              onClick={() => {
                                editCallBack(editFuncData);
                                setActiveRow(index);
                              }}
                            >
                              <FiEdit />
                            </button>

                            <button
                              className="text-center py-3 font-semibold flex justify-center items-center text-xl text-[#c26040]"
                              onClick={() => {
                                setActiveRow(index);
                              }}
                            >
                              <MdPreview />
                            </button>
                          </>
                        )}
                        {showViewCost && item.parcelNo && (
                          <button
                            className="text-center py-3 font-semibold flex justify-center items-center text-xl text-blue-600"
                            onClick={() => fetchParcelCostDetails(item.parcelNo)}
                            disabled={loadingCostData && currentParcelNo === item.parcelNo}
                          >
                            {loadingCostData && currentParcelNo === item.parcelNo ? "Loading..." : "View Cost"}
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination controls */}
      <div
        className={
          fetchedData?.length <= limit
            ? "hidden"
            : "flex items-center gap-x-1 m-auto justify-center mb-11 mt-4"
        }
      >
        <button
          onClick={() => {
            if (
              pageNo === PaginationButtonNumbers[0] &&
              (pageNo < totalPaginationPage) & (pageNo > 1)
            ) {
              if (totalPaginationPage >= pageNo - 4 && pageNo - 4 >= 1)
                skipPaginationNumber(pageNo - 4, pageNo);
              else if (1 > pageNo - 4) skipPaginationNumber(1, pageNo);
            }
            if (1 < pageNo) {
              setPageNo((prev) => prev - 1);
            }
          }}
          className={
            "font-medium  text-base bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-white"
          }
        >
          <MdOutlineArrowBackIosNew className="lg:text-xl text-sm" />
        </button>

        <button
          onClick={() => {
            if ((pageNo <= totalPaginationPage) & (pageNo > 1)) {
              if (totalPaginationPage >= pageNo - 4 && pageNo - 4 >= 1) {
                skipPaginationNumber(pageNo - 4, pageNo);
                setPageNo((prev) => prev - 4);
              } else if (1 > pageNo - 4) {
                skipPaginationNumber(1, pageNo);
                setPageNo((prev) => prev - (pageNo - 1));
              }
            }
          }}
          className={
            "font-medium  text-2xl  rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-black"
          }
        >
          ...
        </button>

        {PaginationButtonNumbers?.map((item) => {
          return (
            <button
              onClick={() => setPageNo(item)}
              className={`font-medium  text-base bg-gradient-to-tr ${
                pageNo === item
                  ? "from-[#b9b89b] to-[#b3b3ae]"
                  : "from-[#6D4C41] to-[#424242]"
              } rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-white`}
              key={item}
            >
              {item}
            </button>
          );
        })}

        <button
          onClick={() => {
            if (pageNo < totalPaginationPage) {
              if (totalPaginationPage >= pageNo + 4) {
                skipPaginationNumber(pageNo, pageNo + 4);
                setPageNo((prev) => prev + 4);
              } else if (totalPaginationPage < pageNo + 4) {
                skipPaginationNumber(pageNo, totalPaginationPage);
                setPageNo((prev) => prev + totalPaginationPage - pageNo);
              }
            }
          }}
          className={
            "font-medium  text-2xl  rounded-[3px]  px-3 lg:px-4 py-[6px]  lg:py-[10px] text-black"
          }
        >
          ...
        </button>
        <button
          onClick={() => {
            if (
              pageNo ===
                PaginationButtonNumbers[PaginationButtonNumbers.length - 1] &&
              pageNo < totalPaginationPage
            ) {
              if (totalPaginationPage >= pageNo + 4)
                skipPaginationNumber(pageNo, pageNo + 4);
              else if (totalPaginationPage < pageNo + 4)
                skipPaginationNumber(pageNo, totalPaginationPage);
            }
            if (totalPaginationPage > pageNo) {
              setPageNo((prev) => prev + 1);
            }
          }}
          className={
            "font-medium  text-base bg-gradient-to-tr from-[#6D4C41] to-[#424242] rounded-[3px] px-3 lg:px-4 py-[6px]  lg:py-[10px] text-white"
          }
        >
          <MdOutlineArrowForwardIos className="lg:text-xl text-sm" />
        </button>
      </div>

      {/* Parcel Cost Details Modal */}
      {showCostModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Parcel Cost Details</h2>
              <button
                onClick={() => setShowCostModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {loadingCostData ? (
              <div className="flex justify-center items-center h-32">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
              </div>
            ) : (
              <>
                <div className="mb-6">
                  <h3 className="text-lg font-semibold mb-2">
                    Parcel Number: {currentParcelNo}
                  </h3>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-700 mb-2">Base Costs</h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span>Sub Total:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.subTotal || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>VAT Tax Amount:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.vaT_TaxAmount || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-700 mb-2">Service Costs</h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span>Route Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.routeCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Shipping Service:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.shippingServiceAmount || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Pick Up Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.pickUpCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-700 mb-2">Item Costs</h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span>Item Type Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.itemTypeCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Weight Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.weightCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Dimension Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.dimensionCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Cargo Cost:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.cargoCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-700 mb-2">Adjustments</h4>
                    <div className="space-y-2">
                      <div className="flex justify-between">
                        <span>Discount Amount:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.discountAmount || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                      <div className="flex justify-between">
                        <span>Extra Packaging:</span>
                        <span>
                          {formatCurrency(
                            parcelCostData?.extraPackagingCost || 0,
                            parcelCostData?.symbol || "GBP",
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-blue-50 p-4 rounded-lg">
                  <div className="flex justify-between items-center">
                    <h4 className="font-bold text-lg">Total Amount:</h4>
                    <span className="text-xl font-bold">
                      {formatCurrency(
                        (parcelCostData?.subTotal || 0) +
                          (parcelCostData?.vaT_TaxAmount || 0),
                        parcelCostData?.symbol || "GBP",
                      )}
                    </span>
                  </div>
                </div>
              </>
            )}

            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setShowCostModal(false)}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HistoryTable;